export default __webpack_public_path__ + "static/media/Radhika_Iyengar-Emens_AHV_In_Moms_We_Trust.66164050.jpg";